<template>
  <div class="ec-wrapper-for-accountMenu" :class="{'has-three-chars': isLongerThanThree}">
    <account-dropdown
      v-if="user"
      :user="user.user"
      :company="user.company"
      :accounts="user.companies"
      :settings-link="'https://www.eventsuite.com/settings?app=eventcalculator'"
      :active-account-text="'Aktiver Account'"
      :other-accounts-text="'Account Wechseln'"
      :settings-text="'Einstellungen'"
      :colors="accountDropdownColors()"
      :asset-path="esAssetPath"
      @switch="toggleAccountMenu"
      @logout="logout"
    />
  </div>
</template>
<script>
import AccountDropdown from 'account-dropdown'
import { replace } from 'lodash'
import { redirect } from './utility'

/**
 * Topbar ist zurzeit noch nicht vollstaendig.
 * Es umfasst aktuell nur den account Dropdown sollte aber wie bereits der name sagt eigentlich die gesammte Topbar dastellen.
 */

export default { 
    el: '#header-vue',
    name: 'TopBar',
    components: {AccountDropdown},
    data() {
        return {
            user: null,
        }
    },
    created() {
        this.user = Laravel.EventSuite.user
    },
    computed: {
        isLongerThanThree() {
            return (this.user.user.initials.length > 2)
        },
        esAssetPath() {
          return Laravel.EventSuite.avatar_image_url
        }
    },
    methods: {
        toggleAccountMenu(account) {
            redirect(replace(Laravel.EventSuite.links.switchAccountBase, '_account_', account))
        },
        logout() {
            axios.post(Laravel.EventSuite.links.logout)
            .then((response) => {
                redirect('/')
            })
        },
        accountDropdownColors () {
          return {
            primary: '#1068DD',
            link: '#333',
            initials: '#808080'
          }
        },
    }
}
</script>
